export default __webpack_public_path__ + "static/feast-1aca118c2772d0eeb71f2a8909cdd2a4.png";